<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right table-actions">
          <div class="show-hidden">
            <label class="form-control-label">
              Show Hidden
            </label>
            <base-switch v-model="showHidden"></base-switch>
          </div>
          <base-button
            type="success"
            size="sm"
            icon="ni ni-fat-add"
            @click="$router.push({name: 'new league'})"
          >
            New League
          </base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th>Name</th>
          <th>Type</th>
          <th>Length</th>
          <th>Current Week</th>
          <th>Public</th>
          <th>Players</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <div class="name" @click="$router.push({name: 'view league', params: {id: row.id}})">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </th>
          <td class="type">
            {{row.type.replace('_', ' ')}}
          </td>
          <td>
            {{row.weeks}} Weeks
          </td>
          <td>
            {{row.currentWeek}}
          </td>

          <td>
            <badge class="badge-dot mr-4" :type="row.public ? 'success' : 'info'">
              <i :class="`bg-${row.public ? 'success' : 'info'}`"></i>
              <span class="status">{{row.public ? 'Public' : 'Hidden'}}</span>
            </badge>
          </td>

          <td>
            {{row.players}} {{row.type.includes('team') || row.type.includes('mixed') ? 'Teams' : 'Players'}}
          </td>

          <td class="text-right">
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              href="#"
              @click.prevent="$router.push({name: 'edit league', params: {id: row.id}})"
            >
              <i class="fa fa-edit"></i>
            </a>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :total="this.data.length" :perPage="perPage" v-model="currentPage"></base-pagination>
    </div>

  </div>
</template>
<script>
export default {
  name: 'LeaguesTable',
  props: {
    type: {
      type: String,
    },
    title: String,
    data: {
      type: Array,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      currentPage: 1,
      showHidden: false,
    };
  },
  computed: {
    unpagedData() {
      console.log(this.data);
      if (this.showHidden) {
        return this.data;
      }
      return this.data.filter(item => item.public);
    },
    tableData() {
      const startIndex = this.perPage * (this.currentPage - 1);
      const endIndex = this.perPage * this.currentPage;

      return this.unpagedData.slice(startIndex, endIndex);
    },
  },
};
</script>
<style lang="scss" scoped>
  .type{
    text-transform: capitalize;
  }
  .name{
    cursor: pointer;
  }
  .show-hidden {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    align-items: center;

    label {
      font-weight: bold;
      font-size: .8rem;
      margin-bottom: -.05rem;
    }
  }
  .table-actions {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
</style>
